import { Directive, input } from "@angular/core";
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator  } from "@angular/forms";
import { ChangeDependentValidator } from "./changedependentvalidator";

@Directive({
    selector: "[cannotEqual]",
    providers: [{ provide: NG_VALIDATORS, useExisting: CannotEqualValidatorDirective, multi: true }],
    standalone: true
})

export class CannotEqualValidatorDirective extends ChangeDependentValidator implements Validator {
    readonly cannotEqual = input<any[]>(undefined);

    constructor(){
        super(["cannotEqual"]);
    }

    validate(control: AbstractControl): ValidationErrors | null {
        if (this.cannotEqual().indexOf(control.value) >= 0) {
             return  { "cannotEqual": `Field cannot be ${control.value}` };
        }

        return null;
    }
}